module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-tabletPro-es.c73ad8b2.png";